import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

const Accelerate = () => {
  return (
    <div className="accelerate-section">
      <Container fluid className="py-5">
        <Row className="align-items-center">
          {/* Left Side: Text and Button */}
          <Col md={6} className="text-section">
            <h1 className="accelerate-title">
              Partner with CLIF AI to boost placements and future-proof your
              institution.
            </h1>
            <p className="accelerate-subtitle">
              CLIF AI empowers colleges and universities to significantly
              improve student placements by identifying skill gaps, offering
              targeted upskilling, and connecting students with industry
              opportunities. By integrating CLIF AI, institutions enhance their
              credibility among students, parents, and recruiters—showcasing a
              commitment to cutting-edge career support. This partnership not
              only boosts immediate outcomes but also ensures your campus stays
              relevant and future-ready in a rapidly evolving job market.
            </p>
            <a href="/subscription">
              <button type="button" class="btn-outline-primary login-btn">
                Start a Free Trial Now
              </button>
            </a>
          </Col>

          {/* Right Side: Video Placeholder */}
          <Col md={6} className="video-section">
            <div className="video-placeholder hackathon-image">
              <img
                src="../../../images/recruiters/group-6.jpg"
                alt="Chris Jackson"
                className="expert-img"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Accelerate;
